import StoreConfig from '@/config';

export const CURRENT_STORE_COUNTRY_NAME =
  StoreConfig.available_countries.find(x => x.code === process.env.NEXT_PUBLIC_STORE_VIEW_CODE)?.name || '';
